import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* fetchCitiesOfCountry({ data, callbacks }) {
  try {
    const response = yield call(api.fetchCitiesOfCountry, data);
    yield put(Actions.fetchCitiesOfCountrySuccess(response?.data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, response.data);
    }
  } catch (error) {
    yield put(Actions.fetchCitiesOfCountryFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchFetchCity() {
  yield takeLatest(
    Actions.FETCH_CITIES_OF_COUNTRY_REQUEST,
    fetchCitiesOfCountry
  );
}

export default function* list() {
  yield all([fork(watchFetchCity)]);
}
